/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-nested-ternary */

import { CloseIcon } from '@chakra-ui/icons';
import { Button, ButtonGroup, IconButton } from '@chakra-ui/react';
import { DropdownProps } from '@components/Filters/interfaces';
import React, { useCallback } from 'react';

import { Label } from './styles';

const ChakraRadioFilterView: React.FC<any> = ({
  onOpen,
  onSelect,
  selected,
  title,
  isMulti,
  initialSelected,
  onClear,
  options,
}) => {
  const getOptionLabel = useCallback((value: string) => {
      const option = options.find((option) => option?.value === value);

      return option?.key || value;
    },
    [options],
  );

  if (!selected) return <></>;

  return (
    <>
      <ButtonGroup
        size="sm"
        isAttached
        variant="outline"
        backgroundColor="white"
      >
        <Label>{title}</Label>
        <Button
          aria-label="Action Filter"
          borderInline="none"
          borderStartRadius="0"
          paddingInline="1"
          margin="0"
          width="1px"
          minWidth="1px"
          fontSize="14px"
        >
          :
        </Button>
        <Button
          aria-label="Value Filter"
          borderLeft="none"
          borderRight="none"
          paddingStart="0rem"
          paddingEnd="0.4rem"
          fontSize="14px"
        >
          {Array.isArray(selected) && selected.length > 1
            ? selected?.map((select, index) => {
                if (index > 2) return '';
                if (index === 2) return '...';
                const optionLabel = getOptionLabel(select);
                return selected.length - 1 !== index
                  ? `${optionLabel}, `
                  : `${optionLabel}`;
              })
            : Array.isArray(selected)
            ? getOptionLabel(selected?.[0])
            : getOptionLabel(selected)}
        </Button>
        <IconButton
          // as="button"
          aria-label="Close Filter"
          icon={<CloseIcon />}
          borderLeft="none"
          onClick={onClear}
        />
      </ButtonGroup>
    </>
  );
};

export default ChakraRadioFilterView;
